<template>
  <div>
    <button
      :disabled="disabled"
      class="btn btn-success btn-round btn-sm"
      @click.stop.prevent="$bvModal.show('modal-send-email')"
    >
      {{ $t("message.contracts.send_notifications") }}
    </button>
    <b-modal
      id="modal-send-email"
      hide-footer
      :title="$t('message.contracts.send_notifications')"
      size="lg"
    >
      <div class="row">
        <div class="col-12">
          <strong>
            {{ $t("message.notifications.OrgName") }}: <br />
            <span
              class="badge badge-info mr-2"
              v-for="(selected, i) in selected_search_results"
              :key="i"
            >
              {{ selected.name }}
            </span>
          </strong>
        </div>
        <div class="col-12 mt-2">
          <strong>
            {{ $t("message.notifications.Title") }}: <br />
            <input type="text" class="form-control" :value="subject" disabled />
          </strong>
        </div>
        <div class="col-12 mt-2">
          <strong>
            <div
              id="message-editor"
              contenteditable="true"
              class="bg-light p-4 text-justify"
              v-html="message"
            ></div>
          </strong>
        </div>
        <div class="col-12 mt-3text-center">
          <button class="btn btn-success" @click.stop.prevent="submit_messages">
            {{ $t("message.contracts.offer_answer_send") }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "send-email",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selected_search_results: {
      type: Array,
      //array of objects: { email, name }
    },
  },
  data() {
    return {
      subject: "Invite to ATTIS from {my_company}",
      message: `尊重的 <span class="badge badge-default">{company}</span> 代表！
                            跨境电子系统<a href="https://attistrade.cn">ATTIS</a>(啊提斯)通过电子平台将边境两侧的出口商和进口商、承运商、货运代理、
                            报关行和银行连接起来。这为在国际交易的每个阶段向政府机构提交电子文件提供了一站式服务。
                            <a href="[user_profile]">ATTIS</a>用户邀请您在平台上注册，以便能够访问系统信息、系统服务，与该用户进行谈判和签订
                            外贸合同。
                            <a href="https://attistrade.cn">您可以通过下面的链接进行注册</a>。
                            <br><br>
                            Уважаемый представитель компании <span class="badge badge-default">{company}</span>!
                            Трансграничная электронная система <a href="https://attistrade.kz">АТТИС</a> объединяет экспортеров и импортеров, 
                            перевозчиков, экспедиторов, таможенных брокеров и банки по обе стороны границы на 
                            общей электронной платформе, обеспечив единое окно для подачи электронных 
                            документов в государственные органы на каждом этапе международной сделки.
                            <a href="[user_profile]">Пользователь АТТИС</a> предлагает Вам зарегистрироваться на платформе, чтобы у вас 
                            была возможность получить доступ к информации системы, ее сервисам, обсудить и 
                            заключить с данным пользователем внешнеторговый контракт.
                            Зарегистрироваться Вы сможете, перейдя <a href="https://attistrade.kz">по ссылке</a>.
                            <br><br>
                            Dear representative of {company}!
                            Transborder electronic system <a href="https://attistrade.kz">ATTIS</a> connects exporters and importers, carriers, freight 
                            forwarders, customs brokers, and banks on both sides of a border in a common e-platform. This
                            provides a single window to submit e-documents to Government authorities on every stage of a 
                            foreign trade transaction.
                            The <a href="[user_profile]">ATTIS user</a> invites You to register on the platform to be able to get an access to the system
                            information, the system services, to negotiate and to sign foreign trade contract with this user.
                            You can pass through the registration procedure by clicking <a href="https://attistrade.kz">the following link</a>`,
    };
  },
  methods: {
    /**
     * sends email
     */
    submit_messages() {
      var message = document.querySelector("#message-editor").innerHTML;
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        let { org_name: organization } = response.data.organizations;

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
        const yyyy = today.getFullYear();

        this.selected_search_results.forEach((recipient) => {
          var tmp = message
            .replaceAll("{company}", recipient.name)
            .replaceAll("{my_company}", organization)
            .replaceAll(
              "[user_profile]",
              "https://attistrade.kz/ru/#/profile/" + this.current_bin,
            )
            .replaceAll(
              "[user_profile]",
              "https://attistrade.kz/ru/#/profile/" + this.current_bin,
            );
          let subject = this.subject
            .replaceAll("{company}", recipient.name)
            .replaceAll("{my_company}", organization);
          var fd = new FormData();
          fd.append("email", recipient.email);
          fd.append("subject", subject + " " + dd + "." + mm + "." + yyyy);
          fd.append("message", tmp);
          axios
            .post(window.base + "/contract/sendEmail", fd)
            .then((response) => {
              this.$bvModal.hide("modal-send-email");
              new Noty({
                theme: "light",
                type: "success",
                text: this.$root.$t("message.message.invite-ok"),
                timeout: 5000,
              }).show();
            });
        });
      });
    },
  },
};
</script>
